"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactUi = require("@100mslive/react-ui");
var IconButton = (0, _reactUi.styled)(_reactUi.IconButton, {
  width: "$14",
  height: "$14",
  border: "1px solid $borderLight",
  r: "$1",
  variants: {
    active: {
      "false": {
        border: "1px solid transparent",
        color: "$white"
      }
    }
  }
});
var _default = IconButton;
exports["default"] = _default;